import { render, staticRenderFns } from "./bmi-icon.vue?vue&type=template&id=13814b8c&scoped=true"
import script from "./bmi-icon.vue?vue&type=script&lang=js"
export * from "./bmi-icon.vue?vue&type=script&lang=js"
import style0 from "./bmi-icon.vue?vue&type=style&index=0&id=13814b8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13814b8c",
  null
  
)

export default component.exports